module.exports = __webpack_public_path__ + "img/parking-structures-3.ec2f4fa2.jpg";